import request from "@/utils/request"

//扫码登录
export function loginScan(data) {
	return request({
		url: "/api/My/LoginScan",
		method: "post",
		data
	})
}
//验证码
export function getCode() {
	return request({
		url: "/api/My/Code/?t=" + new Date().getTime(),
		method: "get"
	})
}
//登录
export function login(data) {
	return request({
		url: "/api/Login/UserLogin",
		method: "post",
		data
	})
}
export function loginPwd(data) {
	console.log(data)
	return request({
		url: "/api/My/Login",
		method: "post",
		data
	})
}
export function getInfo(token) {
	return request({
		url: "/vue-element-admin/user/info",
		method: "get",
		params: {token}
	})
}
export function logout() {
	return request({
		url: "/vue-element-admin/user/logout",
		method: "post"
	})
}
export function registeredData(data) {
	return request({
		url: "/api/My/Regedit",
		method: "post",
		data
	})
}
export function sendVerificationCode(data) {
	return request({
		url: "/api/My/GetVerificationCode",
		method: "post",
		data
	})
}
export function beforeRegister() {
	return request({
		url: "/api/OMSInfo/BeforeRegister",
		method: "post"
	})
}
export function addAddress(data) {
	// return request({
	//   url: '/api/OMSInfo/BeforeRegister',
	//   method:'post'

	// })
	return new Promise((resolve, reject) => {
		setTimeout(() => {
			resolve()
		}, 200)
	})
}
export function getAddressList() {
	// return request({
	//   url: '/api/OMSInfo/BeforeRegister',
	//   method:'post'

	// })
	return new Promise((resolve, reject) => {
		setTimeout(() => {
			resolve()
		}, 200)
	})
}

export function GetVerificationCode(data) {
	return request({
		url: "/api/My/GetVerificationCode",
		method: "post",
		data
	})
}

// 我的资料
export function GetMyProfile(data) {
	return request({
		url: "/api/My/GetMyInfo",
		method: "post",
		data
	})
}
// 更改我的资料
export function SaveMyInfo(data) {
	return request({
		url: "/api/My/SaveMyInfo",
		method: "post",
		data
	})
}

// 上传图片

export function uploadPic(data) {
	return request({
		url: "/api/Com/UpLoadPic",
		method: "post",
		data
	})
}

// 身份证识别
export function CheckIdPic(data) {
	return request({
		url: "/api/My/CheckIdPic",
		method: "post",
		data
	})
}
// 保存身份证识别

export function RealnameAuth(data) {
	return request({
		url: "/api/My/RealnameAuth",
		method: "post",
		data
	})
}
// 获取实名认证信息

export function GetRealnameAuth(data) {
	return request({
		url: "/api/My/GetRealnameAuth",
		method: "post",
		data
	})
}
//   我的顾问

export function GetSalesConsultant(data) {
	return request({
		url: "/api/My/GetSalesConsultant",
		method: "post",
		data
	})
}
// 我的资金账户

export function QueryMemberMarginTrans(data) {
	return request({
		url: "/api/Auction/QueryMemberMarginTrans",
		method: "post",
		data
	})
}

export function GetMyInfo(data) {
	return request({
		url: "/api/My/GetMyInfo",
		method: "post",
		data
	})
}

// 获取订单数量

export function OrderQty(data) {
	return request({
		url: "/api/Mall/OrderQty",
		method: "post",
		data
	})
}
//忘记密码
export function ForgetPwd(data) {
	return request({
		url: "/api/My/ForgetPwd",
		method: "post",
		data
	})
}
// 修改密码
export function ChangePwd(data) {
	return request({
		url: "/api/My/ChangePwd",
		method: "post",
		data
	})
}
// 验证码登录
export function loginCode(data) {
	return request({
		url: "/api/My/LoginCode",
		method: "post",
		data
	})
}
//检测手机号,注册提交的场合，调用此接口
export function CheckPhone(data) {
	return request({
		url: "/api/My/CheckPhone",
		method: "post",
		data
	})
}
//检测图形验证码,注册提交的场合，调用此接口
export function CheckCode(data) {
	return request({
		url: "/api/My/CheckCode",
		method: "post",
		data
	})
}
//删除发票信息,[开票信息]画面，保存的场合，调用此接口；
export function DelInvoice(data) {
	return request({
		url: "/api/My/DelInvoice",
		method: "post",
		data
	})
}

// 碳账户
export function GetCarbonEmission(data) {
	return request({
		url: "/api/My/GetCarbonEmission",
		method: "post",
		data
	})
}
// 碳账户 详细

export function GetALLCarbonEmission(data) {
	return request({
		url: "/api/My/GetALLCarbonEmission",
		method: "post",
		data
	})
}
// 减碳攻略

export function QueryCarbonEmissionStandard(data) {
	return request({
		url: "/api/Home/QueryCarbonEmissionStandard",
		method: "post",
		data
	})
}
// 标签栏上的 帮助中心

export function Helper(data) {
	return request({
		url: "/api/Home/Helper",
		method: "post",
		data
	})
}

// 微信扫一扫成功之后，未注册，跳转 绑定手机号页

export function SavePhoneUnionID(data) {
	return request({
		url: "/api/My/SavePhoneUnionID",
		method: "post",
		data
	})
}
